import { VStack } from '@chakra-ui/react'
import React from 'react'

const FullVstack = (props) => {
  return (
    <VStack
      width="full"
      alignItems="stretch"
      bg="white"
      p="2"
      flex="1"
      borderRadius="sm"
      boxShadow="sm"
      {...props}
    />
  )
}

export default FullVstack
